import React from "react";
import helpers from "@src/../js/helpers";
import useHeaderMenuStore from '@src/stores/HeaderMenuStore';

export function HeaderActionCart({ settings, isMobile, cartItemCount }) {

    const { section } = settings;

    const text_style = section.header_font_type;
    const openMenu = useHeaderMenuStore((state) => state.openMenu)

    settings.show_cart_in_header = false;

    return (
        <>
            {settings.show_cart_in_header && (
            <div
                className="header-action__link flex items-center relative [&>svg]:h-[28px] cursor-pointer"
                // x-on:click="$store.global.toggleMinicart()"
                onMouseEnter={() => openMenu("CART", isMobile)}
                onClick={() => openMenu("CART", isMobile)}
            >
                {section.show_text_no_icons_cart && !isMobile ? (
                    <span className={`${text_style}`}>BAG</span>
                ) : (
                    <i className={`${settings.section.cart_icon}  text-lg`}></i>
                )}
                {(cartItemCount) > 0 && !isMobile && (
                    <div className={`header-item-count ${text_style}`}>
                        <span>({cartItemCount})</span>
                    </div>
                )}
                {(cartItemCount) > 0 && isMobile && (
                    <div className="header-item-count--mobile">
                        <span>{cartItemCount}</span>
                    </div>
                )}
            </div>)}
        </>
    );
}
